import car_1_imgUrl from "@/assets/images/features/car_1.png";
import car_2_imgUrl from "@/assets/images/features/car_2.png";
import car_3_imgUrl from "@/assets/images/features/car_3.png";

export const vehicleAndGroupListItemOptions = [
  {
    iconColor: "#8D99FF",
    label: "Group name",
    plus: 2,
    actions: [
      {
        url: car_1_imgUrl,
        color: "#824CF2"
      },
      {
        url: car_2_imgUrl,
        color: "#47B4E3"
      },
      {
        url: car_3_imgUrl,
        color: "#FF6B00"
      }
    ]
  },
  {
    iconColor: "#47B4E3",
    label: "Pastoral staff",
    plus: 4,
    actions: [
      {
        url: null,
        color: "#FF62B5"
      },
      {
        url: null,
        color: "#47B4E3"
      },
      {
        url: car_3_imgUrl,
        color: "#FF6B00"
      }
    ]
  },
  {
    iconColor: "#FAB632",
    label: "Heads of year",
    plus: null,
    actions: [
      {
        url: car_2_imgUrl,
        color: "#47B4E3"
      },
      {
        url: null,
        color: "#FF6B00"
      }
    ]
  }
];